import { css } from "../../../component-styles";

export const sansFonts = ["manrope-font.css"];

export const sans = css`
  .headline {
    font-family: "Manrope", sans-serif;
    font-weight: 600;
    letter-spacing: 0;
    text-wrap: balance;
  }
  .section-title {
    font-family: "Manrope", sans-serif;
    font-weight: 600;
    letter-spacing: 0;
  }
  .card-title {
    font-family: "Manrope", sans-serif;
    font-weight: 600;
    letter-spacing: 0;
  }
  .metric-value {
    font-family: "Manrope", sans-serif;
    font-weight: 600;
    letter-spacing: 0;
  }
  .quote {
    font-family: "Manrope", sans-serif;
    font-style: italic;
  }
  .kicker, .subtitle, .card-description, .meta, .company {
    font-family: "Manrope", sans-serif;
  }
  .brand-nav-link, .brand-nav-title, .brand-footer-line {
    font-family: "Manrope", sans-serif;
  }
`;
